export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_COURSES = 'SET_COURSES';
export const SET_LOADING = 'SET_LOADING';
